import { render } from "./ToggleSwitch.vue?vue&type=template&id=0ddb3cc4&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=0ddb3cc4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ddb3cc4"

export default script